<template>
  <div>
    <v-autocomplete
      hide-details
      :value="value"
      clearable
      :items="propertyList"
      dense
      flat
      attach
      filled
      :placeholder="placeholder"
      item-color="cyan"
      color="cyan"
      solo
      item-text="barcode"
      item-value="id"
      :loading="isLoading"
      :menu-props="{
        contentClass: isLoading ? 'autocomplete-dropdown-menu is-loading' : '',
      }"
      v-bind="$attrs"
      @change="selectProperty"
      @click:clear="$emit('click:clear')"
      :search-input.sync="searchInput"
      :filter="filterProperties"
    >
      <template v-slot:no-data>
        <v-list-item>
          <div
            v-if="isLoading"
            class="w-100 d-flex align-center justify-center py-2"
          >
            <v-progress-circular indeterminate color="cyan" />
          </div>
          <v-list-item-title v-else v-html="`No ${placeholder} Found.`" />
        </v-list-item>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-icon class="mr-3">
          <v-icon large>mdi-home-map-marker</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <div class="d-flex align-center">
            <Barcode class="mr-2" :barcode="item.barcode" />
            <v-chip
              v-if="item.is_tenant"
              class="mx-1"
              label
              small
              color="green"
              outlined
            >
              Tenant
            </v-chip>
            <v-chip
              label
              small
              class="ml-1"
              :color="getLocationLabel(item) === 'Billing' ? 'orange' : 'cyan'"
              outlined
            >
              {{ getLocationLabel(item) }}
            </v-chip>
          </div>
          <v-list-item-title
            class="text-capitalize font-weight-500 font-size-16"
          >
            {{ get_formatted_property(item) }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import { SET_FILTER_PROPERTY_LIST } from "@/core/services/store/customer.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
export default {
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  name: "property-dropdown",
  components: {
    Barcode,
  },
  data() {
    return {
      isLoading: false,
      propertyList: [],
      timeout: null,
      searchInput: "",
      timeoutLimit: 1000,
    };
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    customerId: {
      type: [String, Number, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Site Location",
    },
    type: {
      type: String,
      default: null,
    },
  },
  watch: {
    customerId() {
      this.isLoading = true;
      this.propertyList = [];
      this.getProperties();
    },
    searchInput() {
      this.doTypingSearch();
    },
  },
  methods: {
    doTypingSearch() {
      this.isLoading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.doSearch();
      }, this.timeoutLimit);
    },
    filterProperties(item, queryText) {
      const itemText = `${
        item.display_name || item.barcode || ""
      } ${this.getLocationLabel(item)}`;
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    getLocationLabel(item) {
      const type = Number(item.type);
      const isSame = Number(item.is_same);
      if (type === 1 && isSame === 1) {
        return "Site Location & Billing";
      }
      if (type === 1) {
        return "Site Location";
      }
      return "Billing";
    },
    get_formatted_property(row) {
      const tempArr = [];
      if (row.unit_no) tempArr.push(row.unit_no);
      if (row.street_1) tempArr.push(row.street_1);
      if (row.street_2) tempArr.push(row.street_2);
      if (row.zip_code) tempArr.push(row.zip_code);
      if (row.country_name) tempArr.push(row.country_name);
      else if (row.country) tempArr.push(row.country);
      return tempArr.join(", ");
    },
    doSearch() {
      const param = this.searchInput || "";
      if (param.length < 3) {
        this.isLoading = false;
        return;
      }
      const selectedProperty = this.propertyList.find(
        (row) => row.id === this.value
      );
      if (selectedProperty?.id && selectedProperty.display_name === param) {
        this.isLoading = false;
        return;
      }
      this.getProperties(param);
    },
    selectProperty(value) {
      this.searchInput = "";
      this.$nextTick(() => {
        this.$emit("input", value);
        this.$emit("change", value);
        const valObj = this.propertyList.find((row) => row.id === value);
        this.$emit("change:object", valObj);
      });
    },
    getProperties(search = "") {
      if (this.propertyList.length && !search && this.customerId) {
        this.isLoading = false;
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: `property-list/${this.customerId ?? ""}`,
          data: { search, value: this.value, type: this.type },
        })
        .then(({ data }) => {
          this.propertyList = data;
          this.$store.commit(SET_FILTER_PROPERTY_LIST, this.propertyList);
        })
        .catch((error) => {
          this.$emit("error", error.message || "Failed to load properties");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    if (!this.value || !this.propertyList.length) {
      this.getProperties();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>
